<div class="post__activity flex">
  <div
    class="activity__action"
    [ngClass]="{ active: landingPageDataService.isLiked() }"
    (click)="likeToggle()"
  >
    <div class="activity__icon" inlineSVG="landing/like.svg"></div>
    <p>
      <span>{{
        (landingPageDataService.isLiked() ? "Liked" : "Like")
          | translate
          | async
      }}</span>
    </p>
  </div>
  <div class="activity__action">
    <div class="activity__icon" inlineSVG="landing/comment.svg"></div>
    <p>
      <span translate>Comments</span>
    </p>
  </div>
  <div class="activity__action" (click)="shareToggle()">
    <div class="activity__icon" inlineSVG="landing/share.svg"></div>
    <p>
      <span translate>Share</span>
    </p>
    <div class="share__dropdown" [ngClass]="{ open: shareModal }">
      <ul class="flex flex-col gap-3">
        <li (click)="share('facebook')">
          <div inlineSVG="share__product/facebook.svg"></div>
          <span translate>Facebook</span>
        </li>
        <li (click)="share('whatsapp')">
          <div inlineSVG="share__product/whatsapp.svg"></div>
          <span translate>WhatsApp</span>
        </li>
        <li (click)="share('messenger')">
          <div inlineSVG="share__product/messenger.svg"></div>
          <span translate>Messenger</span>
        </li>
        <li (click)="copyLink()">
          <div inlineSVG="share__product/link.svg"></div>
          <span translate>Copy URL</span>
        </li>
      </ul>
    </div>
  </div>
</div>
